import React from "react";
import styled from 'styled-components';
import nextIcon from '../../assets/dashboard/nextIcon.png'
import greyNextIcon from '../../assets/dashboard/greyNextIcon.png'
import prevIcon from '../../assets/dashboard/prevIcon.png'
import greyPrevIcon from '../../assets/dashboard/greyPrevIcon.png'

export const Pagination = ({ total, size, page, handlePageChange, setPage }) => {

  const totalPages = Math.ceil(+total / +size);

  return (
    <PaginationWrapper>
      <span className="text">Page {page} of {totalPages}</span>
      <PaginationButton
        onClick={() => handlePageChange(false)}
        inActive={page == 1}
      >
        <img src={greyPrevIcon} />
      </PaginationButton>

      <PaginationButton
        onClick={() => handlePageChange(true)}
        inActive={total / (page * size) < 1}
      >
        <img src={greyNextIcon} />
      </PaginationButton>
    </PaginationWrapper>
  );
};

export const PaginationSizeFilter = ({ size, handleSizeChange }) => {
  return (
    <SelectWrapper>
      <label htmlFor="pageSize">Rows per page </label>
      <Select id="pageSize" value={size} onChange={handleSizeChange}>
        <option value={5}>5</option>
        <option value={10}>10</option>
        <option value={15}>15</option>
      </Select>
    </SelectWrapper>
  );
};

const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 2rem;
  height: 4rem;
  box-sizing: border-box;
  font-family: var(--font);
  background-color: var(--background-color);
  color: var(--color);
  gap: 1rem;

  label {
    font-weight: 500;
    font-size: 1.5rem;
    font-family: var(--font);
    color: var(--color);
  }
`;

const Select = styled.select`
  width: 6rem;
  padding: 0.3rem 0rem 0.3rem 1rem;
  margin-left: 0.5rem;
  box-sizing: border-box;
  font-size: 1.5rem;
  font-weight: 600;
  border: 0.15rem solid var(--color);
  border-radius: 0.5rem;
  font-family: var(--font);
  background-color: var(--background-color);
  color: var(--color);


  option {
    font-family: var(--font);
    color: var(--color);
  }
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  align-items: center;
  font-family: var(--font);


  .text {
    font-weight: 500;
    font-size: 1.5rem;
    font-family: var(--font);
    color: var(--color);
  }
`;

const PaginationButton = styled.button`
  width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0.15rem solid var(--color);
  border-radius: 0.5rem;
  cursor: ${({ inActive }) => (inActive ? 'default' : 'pointer')};
  font-family: var(--font);
  background-color: var(--background-color);
  color: var(--color);

  &:hover {
    opacity: 0.75;
  }

  img {
    width: 1.5rem;
  }
`;
